// Swipe cards (assets/hf-swipe.css): the cards rise in one after another the first time the row
// is seen, a phone row nudges once so it reads as swipeable, and the dot follows the card in view.
document.querySelectorAll('.hf-swipe').forEach((swipe) => {
  const track = swipe.querySelector('.hf-swipe__track');
  const dots = swipe.querySelectorAll('.hf-swipe__dot');
  if (!track) return;
  const cards = [...track.children];

  if (dots.length) {
    const seen = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = cards.indexOf(e.target);
        dots.forEach((d, n) => d.toggleAttribute('data-on', n === i));
      });
    }, { root: track, threshold: 0.6 });
    cards.forEach((c) => seen.observe(c));
  }

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  swipe.classList.add('is-armed');
  const enter = new IntersectionObserver((entries) => {
    if (!entries.some((e) => e.isIntersecting)) return;
    enter.disconnect();
    swipe.classList.add('is-in');
    if (track.scrollWidth <= track.clientWidth + 4) return;
    let touched = false;
    track.addEventListener('pointerdown', () => { touched = true; }, { once: true });
    setTimeout(() => {
      if (touched || track.scrollLeft > 0) return;
      // Snapping would catch the nudge and carry it to the next card, so it is off until it ends.
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: 56, behavior: 'smooth' });
      setTimeout(() => { track.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
      setTimeout(() => { track.style.scrollSnapType = ''; }, 1300);
    }, 1100);
  }, { threshold: 0.4 });
  enter.observe(swipe);
});
